import axios from '~/common/plugins/axios.js'
export const state = () => ({
    data: [],
    pagination: {
        listName: "供货子项",
        total: 0,
        current: 1,
        page_size: 50,
    },
    options:[],
    operateData:[],
    operateIndex: -1,
    decimal:4,
    orderVisible:false
})

export const mutations = {
    setData(state, data) {
        state.data = data
    },
    setDataCount(state, data) {
        state.pagination.total = data
    },
    setOperateData(state, data) {
        state.operateData = data
    },
    setOperateIndex(state, data) {
        state.operateIndex = data
    },
    setDecimal(state, data) {
        state.decimal = data
    },
    setPagination(state, data) {
        state.pagination.current = data
    },
    setOptions(state, data) {
        state.options = data
    },
    setOrderVisible(state,data){
        state.orderVisible = data
    }
}

export const actions = {
    async getData({dispatch,commit}, {parameter}) {
        const {data:{list,pagination}} = await axios.$post(`/rest/store/biz/v3/supitems/search`, {...parameter});
        let newData=[];
        if(list){
             newData=list.map((item)=>{
                if(item.price){
                    item.price_title=item.price.map(item=>{
                        return (item.qty+":"+item.price_unit)
                    }).join("\r");
                }
                return item;
            });
        }
        commit('setData', newData);
        if(pagination && pagination.total){
            if(Math.ceil(pagination.total/pagination.page_size)<pagination.current){
                parameter.current = 1;
                dispatch('getData',{parameter:parameter})
            }
            commit('setDataCount', pagination.total);
        }else{
            commit('setDataCount', 0);
        }

    },
    async getInfo({commit}, {parameter}) {
        const data = await axios.$get(`/rest/store/biz/v3/supitems/${parameter.id}`);
        return data;
    },
    async add({commit}, {parameter}) {
        const data = await axios.$post("/rest/store/biz/v3/avabLine/bulk", {...parameter});
        return data;
    },
    async edit({commit}, {parameter}) {
        const data = await axios.$put(`/rest/store/biz/v3/supitems`, {...parameter});
        return data;
    },
    async del({commit}, {parameter}) {
        const data = await axios.$delete(`/rest/store/biz/v3/supitems`,{data:{...parameter}});
        return data;
    },
    updateOperateData({commit}, {parameter}){
        commit('setOperateData', parameter)
    },
    updatePagination({commit}, {parameter}){
        commit('setPagination', parameter)
    },
    updateOptions({commit}, {parameter}){
        commit('setOptions', parameter)
    },
    updateOperateIndex({commit}, {parameter}){
        commit('setOperateIndex', parameter)
    },
    updateDecimal({commit}, {parameter}){
        commit('setDecimal', parameter)
    }
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
